export function isValidEmail({ email }: { email: string }): boolean {
    if (email && email.length > 3 && email.includes("@") && email.includes(".")) {
        return true;
    } else {
        return false;
    }
}
